import Swiper, { Autoplay, Navigation, Keyboard, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([ Autoplay, Navigation, Keyboard, Pagination ])

class SwiperClass {
    setSwiper(selector, settings) {
        const swiper = document.querySelector(selector)

        if (swiper && swiper.swiper) {
            //swiper.swiper.destroy()
        }
        
        if (swiper) {
            new Swiper(selector, settings)
        }
    }

    init(selector, settings) {
        const swiperContainer = document.querySelector(selector)

        if (!swiperContainer) return

        const swiperInnerNode = document.querySelector('.inner'),
        setSwiperWidth = () => {
            swiperContainer.style.width = '0px';
            
            setTimeout(() => {
                var w = swiperInnerNode.clientWidth - 40
            
                swiperContainer.style.width = w + 'px'
            
                this.setSwiper(selector, settings)
            }, 0)
        }
    
        setSwiperWidth()
    
        window.addEventListener('resize', setSwiperWidth)
    }
}

const _Swiper = new SwiperClass()

export default _Swiper